import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectItem} from 'helpers/hooks/utils';
import StyledTasksList from 'components/organisms/Lists/TasksList/TasksList.styles';
import TaskCard from 'components/molecules/Cards/TaskCard/TaskCard';
import Component from 'components/organisms/Utils/Component/Component';
import utils from 'helpers/utils';
import {useClientCallbacks} from 'services/client/client.utils';

const TasksList = React.forwardRef((props, ref) => {
  const {
    tasks,
    Card,
    onClick,
    isLoading,
    loaderCount,
    TaskCardProps,
    ...innerProps
  } = useComponentProps({
    loaderCount: 6,
    ...props
  }, 'TasksList');

  const clientCallbacks = useClientCallbacks();

  const TaskCardDefault = ({task, ...props}) => {
    return <TaskCard task={task}
                     fullHeight={innerProps.orientation === 'horizontal'}
                     fullWidth={innerProps.orientation !== 'vertical'}
                     {...props}/>;
  };

  const CardMemo = useEffectItem(Card ?? TaskCardDefault);
  const renderCard = (task, state) => {
    return <Component Original={CardMemo}
                      task={task}
                      callbacks={clientCallbacks}
                      selected={state.selected}
                      onClick={!state.isLoading ? onClick : null}
                      isLoading={state.isLoading}
                      {...TaskCardProps} />
  };

  const isItemEqual = (task, selected) => {
    return +task.commentId === +selected.commentId;
  }

  return <StyledTasksList ref={ref} {...innerProps}
                          data={tasks?.data}
                          count={tasks.meta?.resultsCount}
                          dataKey="commentId"
                          isItemEqual={isItemEqual}
                          renderItem={renderCard}
                          isLoading={isLoading || (tasks.status.isLoading || !utils.isDefined(tasks?.data))}
                          showProgressBar={tasks.status.isLoadingNext}
                          onFetchMore={tasks.query?.fetchNextPage}
                          loaderCount={loaderCount}
                          ListProps={{
                            track: true,
                            virtualize: true,
                            overscan: 1,
                            estimatedSize: 90,
                            gap: 8,
                          }}/>
});

TasksList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  tasks: PropTypes.object,
  Card: PropTypes.any,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  loaderCount: PropTypes.number,
  TaskCardProps: PropTypes.object
};

export default TasksList;
